// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorV2_vendorDetailWrp__f6flO {
  position: relative;
  padding: 16px 24px;
}

.VendorV2_backBtn__2Z\\+bq {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 2px;
  width: fit-content;
}
.VendorV2_backBtn__2Z\\+bq img,
.VendorV2_backBtn__2Z\\+bq svg {
  width: 16px;
  height: 16px;
  display: block;
}
.VendorV2_backBtn__2Z\\+bq span {
  font-weight: 500;
  font: var(--body-font-three);
  color: var(--primary-Text);
  text-transform: capitalize;
}

.VendorV2_contentContainer__\\+b1s5 {
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
  overflow: hidden;
}

.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod {
  margin: -20px;
  height: 215px;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_favoriteBtn__FwF3j {
  padding: 8px;
  position: absolute;
  top: 12px;
  right: 12px;
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
  display: flex;
  align-items: center;
  gap: 8px;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_changeCover__rGSET {
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: var(--border-radius);
  background-color: var(--white);
  border: unset;
  cursor: pointer;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--primary-Text);
  box-shadow: 0px 0px 12px #dddddd;
  line-height: 1;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_changeCover__rGSET span {
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_changeCover__rGSET img,
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_changeCover__rGSET svg {
  width: 100%;
  height: 100%;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_changeCover__rGSET:hover {
  background-color: #f2f6f8;
}
.VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod .VendorV2_coverImg__1glve {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE {
  padding: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: -10px;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_left__x65u3 {
  display: flex;
  align-items: end;
  width: 100%;
  flex: 1 1;
}
@media (max-width: 650px) {
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_left__x65u3 {
    flex-direction: column;
    align-items: start;
    justify-content: start;
    gap: 10px;
  }
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 120px;
  height: 120px;
  background-color: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
  margin-right: 16px;
  overflow: hidden;
  flex-shrink: 0;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m .VendorV2_businessProfilePic__3cUjo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f2f6f8;
  object-fit: cover;
  border-radius: var(--border-radius-full);
  text-align: center;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m .VendorV2_imgIcn__lsyQV img,
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m .VendorV2_imgIcn__lsyQV svg {
  width: 15px;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB {
  padding-top: 30px;
  margin-bottom: 10px;
}
@media (max-width: 650px) {
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB {
    padding-top: 10px;
    width: 100%;
  }
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
@media (max-width: 650px) {
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F {
    justify-content: space-between;
  }
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F h4 {
  font: var(--h5);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 0;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F .VendorV2_topLabel__tXYqx {
  background-color: #9b38bd;
  color: var(--white);
  font: var(--body-font-four);
  font-weight: 500;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 50px;
  line-height: 1;
  text-align: center;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F .VendorV2_topLabel__tXYqx img,
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F .VendorV2_topLabel__tXYqx svg {
  width: 20px;
  height: 20px;
  display: block;
}
.VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB h6 {
  font: var(--body-font-three);
  font-weight: 500;
  margin: 0;
  color: var(--brand);
  margin-bottom: 8px;
}
.VendorV2_topContent__B9bcb .VendorV2_websiteAndChat__BJ0Mx {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.VendorV2_bottomContent__wzc8z {
  margin: 15px 0 0 0;
}
.VendorV2_bottomContent__wzc8z .VendorV2_bottomContentInner__xyxiA {
  padding: 0;
  margin: 0;
}

.VendorV2_cardWrp__qcAsH {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
}
.VendorV2_cardWrp__qcAsH .VendorV2_infoHeader__H-PsL {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.VendorV2_cardWrp__qcAsH .VendorV2_infoHeader__H-PsL h5 {
  font: var(--body-font-two);
  color: var(--primary-Text);
  font-weight: 600;
  margin: 0;
}
.VendorV2_cardWrp__qcAsH .VendorV2_infoHeader__H-PsL .VendorV2_editIcon__UDU0g {
  padding: 0;
}
.VendorV2_cardWrp__qcAsH .VendorV2_infoHeader__H-PsL .VendorV2_editIcon__UDU0g img,
.VendorV2_cardWrp__qcAsH .VendorV2_infoHeader__H-PsL .VendorV2_editIcon__UDU0g svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
}
.VendorV2_cardWrp__qcAsH .VendorV2_businessDetail__0Qc7t h6 {
  font: var(--body-font-four);
  color: var(--brand);
  margin: 0 0 4px 0;
}
.VendorV2_cardWrp__qcAsH .VendorV2_businessDetail__0Qc7t h5 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin: 0;
  font-weight: 500;
}
.VendorV2_cardWrp__qcAsH.VendorV2_mediaInfo__veLIE {
  margin-top: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_mediaInfo__veLIE .VendorV2_mediaImgContainer__KphcO {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  flex-wrap: wrap;
  gap: 10px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_mediaInfo__veLIE .VendorV2_mediaImgContainer__KphcO .VendorV2_mediaImg__xTKce {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: var(--border-radius-large);
}
.VendorV2_cardWrp__qcAsH.VendorV2_mediaInfo__veLIE .VendorV2_mediaImgContainer__KphcO .VendorV2_mediaImg__xTKce img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
  border-radius: var(--border-radius-large);
}
.VendorV2_cardWrp__qcAsH.VendorV2_serviceInfo__-bulb {
  margin-top: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_serviceInfo__-bulb .VendorV2_serviceChipsWrp__tNY5H {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.VendorV2_cardWrp__qcAsH.VendorV2_serviceInfo__-bulb .VendorV2_serviceChipsWrp__tNY5H .VendorV2_chip__YpVTh {
  width: max-content;
  cursor: text;
  color: var(--primary-Text);
  font-weight: 400;
}
.VendorV2_cardWrp__qcAsH.VendorV2_serviceInfo__-bulb .VendorV2_serviceChipsWrp__tNY5H .VendorV2_chip__YpVTh:hover, .VendorV2_cardWrp__qcAsH.VendorV2_serviceInfo__-bulb .VendorV2_serviceChipsWrp__tNY5H .VendorV2_chip__YpVTh:focus {
  background-color: transparent;
  color: var(--brand);
}
.VendorV2_cardWrp__qcAsH.VendorV2_socialInfo__G-uLh {
  margin-top: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_socialInfo__G-uLh .VendorV2_socialInputFieldWrp__erQrT {
  display: flex;
  flex-direction: column !important;
  gap: 8px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh {
  margin-top: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_left__x65u3 {
  background-color: var(--bg3);
  padding: 16px 12px;
  border-radius: var(--border-radius-large);
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq h3 {
  font: var(--h1);
  font-weight: 600;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq img {
  width: 24px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq .VendorV2_reviewAfterImg__gJ2ES {
  transform: scaleX(-1);
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingPercent__GnRZ6 {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 75px;
  justify-content: flex-end;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingPercent__GnRZ6 h5 {
  font: var(--body-font-four);
  color: var(--primary-Text);
  margin: 0;
  font-weight: 500;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingPercent__GnRZ6 img {
  width: 12px;
  height: 12px;
  object-fit: scale-down;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingPercent__GnRZ6 h6 {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin: 0;
  font-weight: 400;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 450px;
  overflow-y: auto;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 12px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerImg__fYAO2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerImg__fYAO2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI {
  flex: 1 1;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI h4 {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 6px;
  text-transform: capitalize;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI ul {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 8px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI ul li img,
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI ul li svg {
  width: 12px;
  height: 12px;
  object-fit: scale-down;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI h5 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH .VendorV2_reviewerContent__EKngI h6 {
  font: var(--body-font-four);
  color: var(--secondary-Text);
}
.VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 {
  margin-top: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packagesWrp__OHuuY {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageItem__1m4IX {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
  background-color: var(--white);
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageImageWrp__Uk38k {
  width: 100%;
  height: auto;
  aspect-ratio: 238/179;
  flex-shrink: 0;
  border-radius: var(--border-radius-large);
  overflow: hidden;
  position: relative;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageImageWrp__Uk38k .VendorV2_packageImage__8bYt8 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageImageWrp__Uk38k .VendorV2_packageImageOverlay__kvbp5 {
  width: fit-content;
  height: fit-content;
  background-color: var(--white);
  color: var(--primary-Text);
  font: var(--body-font-four);
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px;
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 1;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageContent__t5McF {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageTitle__8\\+LWU {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
  margin: 0;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageDescription__mFJEv {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  margin: 0;
  flex: 1 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageFooter__7q2Dn {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packagePrice__bReQO {
  display: flex;
  align-items: center;
  gap: 4px;
}
.VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packagePrice__bReQO .VendorV2_priceValue__q7RAz {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
}

.VendorV2_VendorsListModalMain__9i83D .VendorV2_VendorsListModal__Ne5a\\+ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
@media (max-width: 450px) {
  .VendorV2_VendorsListModalMain__9i83D .VendorV2_VendorsListModal__Ne5a\\+ {
    flex-direction: column;
    align-items: center;
  }
}
.VendorV2_VendorsListModalMain__9i83D .VendorV2_VendorsListModal__Ne5a\\+ .VendorV2_VendorsListModalButtonGroup__uRDKe {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;
}

@media (max-width: 991px) {
  .VendorV2_contentContainer__\\+b1s5 {
    padding: 12px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod {
    height: 160px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE {
    flex-direction: column;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    margin-top: 0;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB {
    margin-bottom: 0;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F h4 {
    font-size: 18px;
    margin-bottom: 0;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F .VendorV2_topLabel__tXYqx img,
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F .VendorV2_topLabel__tXYqx svg {
    width: 15px;
    height: 15px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB h6 {
    font-size: 12px;
    margin-bottom: 0;
  }
  .VendorV2_topContent__B9bcb .VendorV2_websiteAndChat__BJ0Mx {
    margin-bottom: 0;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_socialInfo__G-uLh .VendorV2_socialInputFieldWrp__erQrT {
    flex-direction: column !important;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_socialInfo__G-uLh .VendorV2_socialInputFieldWrp__erQrT .VendorV2_socialInputField__ia8Ga {
    width: 100%;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_left__x65u3 {
    padding: 12px 10px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq {
    margin-bottom: 10px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq h3 {
    font: var(--h3);
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingNumber__dBELq img {
    width: 20px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_ratingPercent__GnRZ6 {
    width: 70px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D {
    gap: 10px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_ratingReviewCard__dSKuh .VendorV2_reviewContentWrp__VbA7D .VendorV2_reviewContent__UCBbH {
    gap: 10px;
    padding-bottom: 10px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageItem__1m4IX {
    gap: 10px;
    padding: 10px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageFooter__7q2Dn {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_viewDetailsBtn__dzdrA {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .VendorV2_vendorDetailWrp__f6flO {
    padding: 16px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_mediaInfo__veLIE .VendorV2_mediaImgContainer__KphcO {
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  }
}
@media (max-width: 575px) {
  .VendorV2_topContent__B9bcb .VendorV2_coverImgWrp__SHQod {
    height: 120px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessAvatar__qLM6m {
    width: 70px;
    height: 70px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F {
    gap: 7px;
    margin-bottom: 2px;
  }
  .VendorV2_topContent__B9bcb .VendorV2_businessDetails__2lVnE .VendorV2_businessName__1q6lB .VendorV2_row__UhP5F h4 {
    font-size: 16px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageItem__1m4IX {
    flex-direction: column;
    gap: 8px;
    padding: 8px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageImageWrp__Uk38k {
    width: 100%;
    height: auto;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_packageFooter__7q2Dn {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .VendorV2_cardWrp__qcAsH.VendorV2_packagesCard__caNM2 .VendorV2_viewDetailsBtn__dzdrA {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/profileCards/VendorV2/index.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,kBAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACD;AACC;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AACF;AAEC;EACC,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;AAAF;;AAIA;EACC,aAAA;EACA,+BAAA;EACA,yCAAA;EACA,gBAAA;AADD;;AAKC;EACC,aAAA;EACA,aAAA;AAFF;AAIE;EACC,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFH;AAKE;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gCAAA;EACA,cAAA;AAHH;AAKG;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAHJ;AAMG;;EAEC,WAAA;EACA,YAAA;AAJJ;AAOG;EACC,yBAAA;AALJ;AASE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAPH;AAWC;EACC,UAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AATF;AAWE;EACC,aAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AATH;AAWG;EAND;IAOE,sBAAA;IACA,kBAAA;IACA,sBAAA;IACA,SAAA;EARF;AACF;AAWE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AATH;AAWG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AATJ;AAYG;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;AAVJ;AAeI;;EAEC,WAAA;AAbL;AAkBE;EACC,iBAAA;EACA,mBAAA;AAhBH;AAkBG;EAJD;IAKE,iBAAA;IACA,WAAA;EAfF;AACF;AAiBG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAfJ;AAiBI;EAND;IAOE,8BAAA;EAdH;AACF;AAgBI;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AAdL;AAiBI;EACC,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAfL;AAiBK;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAfN;AAoBG;EACC,4BAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AArBF;;AAyBA;EACC,kBAAA;AAtBD;AAwBC;EACC,UAAA;EACA,SAAA;AAtBF;;AA2BA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,+BAAA;EACA,yCAAA;AAxBD;AA0BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAxBF;AA0BE;EACC,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,SAAA;AAxBH;AA2BE;EACC,UAAA;AAzBH;AA2BG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AAzBJ;AA+BE;EACC,2BAAA;EACA,mBAAA;EACA,iBAAA;AA7BH;AAgCE;EACC,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AA9BH;AAkCC;EACC,gBAAA;AAhCF;AAkCE;EACC,aAAA;EACA,2DAAA;EACA,eAAA;EACA,SAAA;AAhCH;AAkCG;EACC,WAAA;EACA,iBAAA;EACA,yCAAA;AAhCJ;AAkCI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AAhCL;AAsCC;EACC,gBAAA;AApCF;AAsCE;EACC,aAAA;EACA,QAAA;EACA,eAAA;AApCH;AAsCG;EACC,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;AApCJ;AAsCI;EAEC,6BAAA;EACA,mBAAA;AArCL;AA2CC;EACC,gBAAA;AAzCF;AA2CE;EACC,aAAA;EACA,iCAAA;EACA,QAAA;AAzCH;AA8CC;EACC,gBAAA;AA5CF;AA8CE;EACC,4BAAA;EACA,kBAAA;EACA,yCAAA;AA5CH;AA+CE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA7CH;AA+CG;EACC,eAAA;EACA,gBAAA;AA7CJ;AAgDG;EACC,WAAA;AA9CJ;AAiDG;EACC,qBAAA;AA/CJ;AAmDE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;AAjDH;AAmDG;EACC,2BAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAjDJ;AAoDG;EACC,WAAA;EACA,YAAA;EACA,sBAAA;AAlDJ;AAqDG;EACC,2BAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;AAnDJ;AAuDE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AArDH;AAuDG;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;EACA,oBAAA;AArDJ;AAuDI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AArDL;AAuDK;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AArDN;AAyDI;EACC,SAAA;AAvDL;AAyDK;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,0BAAA;AAvDN;AA0DK;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAxDN;AA4DO;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AA1DR;AA+DK;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AA7DN;AAgEK;EACC,2BAAA;EACA,4BAAA;AA9DN;AAkEI;EACC,mBAAA;EACA,iBAAA;AAhEL;AAsEC;EACC,gBAAA;AApEF;AAsEE;EACC,aAAA;EACA,4DAAA;EACA,SAAA;AApEH;AAuEE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,+BAAA;EACA,yCAAA;EACA,8BAAA;AArEH;AAwEE;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;AAtEH;AAwEG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAtEJ;AAyEG;EACC,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AAxEJ;AA4EE;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA1EH;AA6EE;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AA3EH;AA8EE;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA5EH;AA+EE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AA7EH;AAgFE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AA9EH;AAgFG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;AA9EJ;;AAqFC;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAlFF;AAoFE;EAPD;IAQE,sBAAA;IACA,mBAAA;EAjFD;AACF;AAmFE;EACC,WAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAjFH;;AAsFA;EACC;IACC,aAAA;EAnFA;EAuFA;IACC,aAAA;EArFD;EAwFA;IACC,sBAAA;EAtFD;EAwFC;IACC,WAAA;IACA,YAAA;IACA,kBAAA;IACA,aAAA;EAtFF;EAyFC;IACC,gBAAA;EAvFF;EA0FG;IACC,eAAA;IACA,gBAAA;EAxFJ;EA6FI;;IAEC,WAAA;IACA,YAAA;EA3FL;EAgGE;IACC,eAAA;IACA,gBAAA;EA9FH;EAmGA;IACC,gBAAA;EAjGD;EAuGC;IACC,iCAAA;EArGF;EAuGE;IACC,WAAA;EArGH;EA2GC;IACC,kBAAA;EAzGF;EA4GC;IACC,mBAAA;EA1GF;EA4GE;IACC,eAAA;EA1GH;EA6GE;IACC,WAAA;EA3GH;EA+GC;IACC,WAAA;EA7GF;EAgHC;IACC,SAAA;EA9GF;EAgHE;IACC,SAAA;IACA,oBAAA;EA9GH;EAoHC;IACC,SAAA;IACA,aAAA;EAlHF;EAqHC;IACC,sBAAA;IACA,uBAAA;IACA,QAAA;EAnHF;EAsHC;IACC,WAAA;EApHF;AACF;AAyHA;EACC;IACC,aAAA;EAvHA;EA4HC;IACC,2DAAA;EA1HF;AACF;AA+HA;EAEE;IACC,aAAA;EA9HD;EAkIC;IACC,WAAA;IACA,YAAA;EAhIF;EAoIE;IACC,QAAA;IACA,kBAAA;EAlIH;EAoIG;IACC,eAAA;EAlIJ;EA2IC;IACC,sBAAA;IACA,QAAA;IACA,YAAA;EAzIF;EA4IC;IACC,WAAA;IACA,YAAA;EA1IF;EA6IC;IACC,sBAAA;IACA,uBAAA;IACA,QAAA;EA3IF;EA8IC;IACC,WAAA;EA5IF;AACF","sourcesContent":[".vendorDetailWrp {\r\n\tposition: relative;\r\n\tpadding: 16px 24px;\r\n}\r\n\r\n.backBtn {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tmargin-bottom: 20px;\r\n\tcursor: pointer;\r\n\tpadding: 2px;\r\n\twidth: fit-content;\r\n\r\n\timg,\r\n\tsvg {\r\n\t\twidth: 16px;\r\n\t\theight: 16px;\r\n\t\tdisplay: block;\r\n\t}\r\n\r\n\tspan {\r\n\t\tfont-weight: 500;\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t\ttext-transform: capitalize;\r\n\t}\r\n}\r\n\r\n.contentContainer {\r\n\tpadding: 20px;\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: var(--border-radius-large);\r\n\toverflow: hidden;\r\n}\r\n\r\n.topContent {\r\n\t.coverImgWrp {\r\n\t\tmargin: -20px;\r\n\t\theight: 215px;\r\n\r\n\t\t.favoriteBtn {\r\n\t\t\tpadding: 8px;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 12px;\r\n\t\t\tright: 12px;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t}\r\n\r\n\t\t.changeCover {\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 16px;\r\n\t\t\tright: 16px;\r\n\t\t\tborder-radius: var(--border-radius);\r\n\t\t\tbackground-color: var(--white);\r\n\t\t\tborder: unset;\r\n\t\t\tcursor: pointer;\r\n\t\t\tpadding: 8px 12px;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tbox-shadow: 0px 0px 12px #dddddd;\r\n\t\t\tline-height: 1;\r\n\r\n\t\t\tspan {\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tmargin-right: 8px;\r\n\t\t\t}\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: #f2f6f8;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.coverImg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t}\r\n\t}\r\n\r\n\t.businessDetails {\r\n\t\tpadding: 0;\r\n\t\tdisplay: flex;\r\n\t\talign-items: flex-end;\r\n\t\tjustify-content: space-between;\r\n\t\tgap: 10px;\r\n\t\tflex-wrap: wrap;\r\n\t\tmargin-top: -10px;\r\n\r\n\t\t.left {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: end;\r\n\t\t\twidth: 100%;\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t@media (max-width: 650px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: start;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\tgap: 10px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.businessAvatar {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\t\t\tposition: relative;\r\n\t\t\twidth: 120px;\r\n\t\t\theight: 120px;\r\n\t\t\tbackground-color: var(--white);\r\n\t\t\tborder: 1px solid var(--border);\r\n\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\tmargin-right: 16px;\r\n\t\t\toverflow: hidden;\r\n\t\t\tflex-shrink: 0;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t}\r\n\r\n\t\t\t.businessProfilePic {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: center;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tbackground-color: #f2f6f8;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t\tborder-radius: var(--border-radius-full);\r\n\t\t\t\ttext-align: center;\r\n\t\t\t}\r\n\r\n\t\t\t.imgIcn {\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 15px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.businessName {\r\n\t\t\tpadding-top: 30px;\r\n\t\t\tmargin-bottom: 10px;\r\n\r\n\t\t\t@media (max-width: 650px) {\r\n\t\t\t\tpadding-top: 10px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t.row {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\tmargin-bottom: 8px;\r\n\r\n\t\t\t\t@media (max-width: 650px) {\r\n\t\t\t\t\tjustify-content: space-between;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont: var(--h5);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.topLabel {\r\n\t\t\t\t\tbackground-color: #9b38bd;\r\n\t\t\t\t\tcolor: var(--white);\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tpadding: 4px 10px;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 5px;\r\n\t\t\t\t\tborder-radius: 50px;\r\n\t\t\t\t\tline-height: 1;\r\n\t\t\t\t\ttext-align: center;\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\t\theight: 20px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\th6 {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.websiteAndChat {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n}\r\n\r\n.bottomContent {\r\n\tmargin: 15px 0 0 0;\r\n\r\n\t.bottomContentInner {\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t}\r\n}\r\n\r\n// ==== common card info css =====\r\n.cardWrp {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 12px;\r\n\tmargin: 0;\r\n\tpadding: 16px;\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: var(--border-radius-large);\r\n\r\n\t.infoHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 8px;\r\n\r\n\t\th5 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tmargin: 0;\r\n\t\t}\r\n\r\n\t\t.editIcon {\r\n\t\t\tpadding: 0;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.businessDetail {\r\n\t\th6 {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tmargin: 0 0 4px 0;\r\n\t\t}\r\n\r\n\t\th5 {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tmargin: 0;\r\n\t\t\tfont-weight: 500;\r\n\t\t}\r\n\t}\r\n\r\n\t&.mediaInfo {\r\n\t\tmargin-top: 16px;\r\n\r\n\t\t.mediaImgContainer {\r\n\t\t\tdisplay: grid;\r\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\tgap: 10px;\r\n\r\n\t\t\t.mediaImg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\taspect-ratio: 1 / 1;\r\n\t\t\t\tborder-radius: var(--border-radius-large);\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.serviceInfo {\r\n\t\tmargin-top: 16px;\r\n\r\n\t\t.serviceChipsWrp {\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 8px;\r\n\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t.chip {\r\n\t\t\t\twidth: max-content;\r\n\t\t\t\tcursor: text;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont-weight: 400;\r\n\r\n\t\t\t\t&:hover,\r\n\t\t\t\t&:focus {\r\n\t\t\t\t\tbackground-color: transparent;\r\n\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.socialInfo {\r\n\t\tmargin-top: 16px;\r\n\r\n\t\t.socialInputFieldWrp {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column !important;\r\n\t\t\tgap: 8px;\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&.ratingReviewCard {\r\n\t\tmargin-top: 16px;\r\n\r\n\t\t.left {\r\n\t\t\tbackground-color: var(--bg3);\r\n\t\t\tpadding: 16px 12px;\r\n\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t}\r\n\r\n\t\t.ratingNumber {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\th3 {\r\n\t\t\t\tfont: var(--h1);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t}\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 24px;\r\n\t\t\t}\r\n\r\n\t\t\t.reviewAfterImg {\r\n\t\t\t\ttransform: scaleX(-1);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.ratingPercent {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 6px;\r\n\t\t\twidth: 75px;\r\n\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\th5 {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t}\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 12px;\r\n\t\t\t\theight: 12px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\r\n\t\t\th6 {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.reviewContentWrp {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 16px;\r\n\t\t\tmax-height: 450px;\r\n\t\t\toverflow-y: auto;\r\n\r\n\t\t\t.reviewContent {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: flex-start;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\tborder-bottom: 1px solid var(--border);\r\n\t\t\t\tpadding-bottom: 12px;\r\n\r\n\t\t\t\t.reviewerImg {\r\n\t\t\t\t\twidth: 40px;\r\n\t\t\t\t\theight: 40px;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tflex-shrink: 0;\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.reviewerContent {\r\n\t\t\t\t\tflex: 1;\r\n\r\n\t\t\t\t\th4 {\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\tmargin-bottom: 6px;\r\n\t\t\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tul {\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\talign-items: center;\r\n\t\t\t\t\t\tgap: 2px;\r\n\t\t\t\t\t\tmargin-bottom: 8px;\r\n\r\n\t\t\t\t\t\tli {\r\n\r\n\t\t\t\t\t\t\timg,\r\n\t\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\t\twidth: 12px;\r\n\t\t\t\t\t\t\t\theight: 12px;\r\n\t\t\t\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\th5 {\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\th6 {\r\n\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:last-child {\r\n\t\t\t\t\tborder-bottom: none;\r\n\t\t\t\t\tpadding-bottom: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.packagesCard {\r\n\t\tmargin-top: 16px;\r\n\r\n\t\t.packagesWrp {\r\n\t\t\tdisplay: grid;\r\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n\t\t\tgap: 16px;\r\n\t\t}\r\n\r\n\t\t.packageItem {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 12px;\r\n\t\t\tpadding: 12px;\r\n\t\t\tborder: 1px solid var(--border);\r\n\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\tbackground-color: var(--white);\r\n\t\t}\r\n\r\n\t\t.packageImageWrp {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: auto;\r\n\t\t\taspect-ratio: 238 / 179;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tborder-radius: var(--border-radius-large);\r\n\t\t\toverflow: hidden;\r\n\t\t\tposition: relative;\r\n\r\n\t\t\t.packageImage {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: cover;\r\n\t\t\t}\r\n\r\n\t\t\t.packageImageOverlay {\r\n\t\t\t\twidth: fit-content;\r\n\t\t\t\theight: fit-content;\r\n\t\t\t\tbackground-color: var(--white);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tpadding: 4px 8px;\r\n\t\t\t\tborder-radius: 8px;\r\n\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tbottom: 8px;\r\n\t\t\t\tright: 8px;\r\n\t\t\t\tz-index: 1;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.packageContent {\r\n\t\t\tflex: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t}\r\n\r\n\t\t.packageTitle {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tmargin: 0;\r\n\t\t}\r\n\r\n\t\t.packageDescription {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 400;\r\n\t\t\tcolor: var(--secondary-Text);\r\n\t\t\tmargin: 0;\r\n\t\t\tflex: 1;\r\n\t\t\tdisplay: -webkit-box;\r\n\t\t\t-webkit-line-clamp: 2;\r\n\t\t\tline-clamp: 2;\r\n\t\t\t-webkit-box-orient: vertical;\r\n\t\t\toverflow: hidden;\r\n\t\t\ttext-overflow: ellipsis;\r\n\t\t\tline-height: 1.4;\r\n\t\t}\r\n\r\n\t\t.packageFooter {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 8px;\r\n\t\t}\r\n\r\n\t\t.packagePrice {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\t.priceValue {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.VendorsListModalMain {\r\n\t.VendorsListModal {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tgap: 16px;\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: center;\r\n\t\t}\r\n\r\n\t\t.VendorsListModalButtonGroup {\r\n\t\t\twidth: 100%;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: end;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 16px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.contentContainer {\r\n\t\tpadding: 12px;\r\n\t}\r\n\r\n\t.topContent {\r\n\t\t.coverImgWrp {\r\n\t\t\theight: 160px;\r\n\t\t}\r\n\r\n\t\t.businessDetails {\r\n\t\t\tflex-direction: column;\r\n\r\n\t\t\t.businessAvatar {\r\n\t\t\t\twidth: 80px;\r\n\t\t\t\theight: 80px;\r\n\t\t\t\tmargin-right: 10px;\r\n\t\t\t\tmargin-top: 0;\r\n\t\t\t}\r\n\r\n\t\t\t.businessName {\r\n\t\t\t\tmargin-bottom: 0;\r\n\r\n\t\t\t\t.row {\r\n\t\t\t\t\th4 {\r\n\t\t\t\t\t\tfont-size: 18px;\r\n\t\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.topLabel {\r\n\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\twidth: 15px;\r\n\t\t\t\t\t\t\theight: 15px;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\tmargin-bottom: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.websiteAndChat {\r\n\t\t\tmargin-bottom: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t.cardWrp {\r\n\t\t&.socialInfo {\r\n\t\t\t.socialInputFieldWrp {\r\n\t\t\t\tflex-direction: column !important;\r\n\r\n\t\t\t\t.socialInputField {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.ratingReviewCard {\r\n\t\t\t.left {\r\n\t\t\t\tpadding: 12px 10px;\r\n\t\t\t}\r\n\r\n\t\t\t.ratingNumber {\r\n\t\t\t\tmargin-bottom: 10px;\r\n\r\n\t\t\t\th3 {\r\n\t\t\t\t\tfont: var(--h3);\r\n\t\t\t\t}\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.ratingPercent {\r\n\t\t\t\twidth: 70px;\r\n\t\t\t}\r\n\r\n\t\t\t.reviewContentWrp {\r\n\t\t\t\tgap: 10px;\r\n\r\n\t\t\t\t.reviewContent {\r\n\t\t\t\t\tgap: 10px;\r\n\t\t\t\t\tpadding-bottom: 10px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.packagesCard {\r\n\t\t\t.packageItem {\r\n\t\t\t\tgap: 10px;\r\n\t\t\t\tpadding: 10px;\r\n\t\t\t}\r\n\r\n\t\t\t.packageFooter {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: flex-start;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.viewDetailsBtn {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.vendorDetailWrp {\r\n\t\tpadding: 16px;\r\n\t}\r\n\r\n\t.cardWrp {\r\n\t\t&.mediaInfo {\r\n\t\t\t.mediaImgContainer {\r\n\t\t\t\tgrid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 575px) {\r\n\t.topContent {\r\n\t\t.coverImgWrp {\r\n\t\t\theight: 120px;\r\n\t\t}\r\n\r\n\t\t.businessDetails {\r\n\t\t\t.businessAvatar {\r\n\t\t\t\twidth: 70px;\r\n\t\t\t\theight: 70px;\r\n\t\t\t}\r\n\r\n\t\t\t.businessName {\r\n\t\t\t\t.row {\r\n\t\t\t\t\tgap: 7px;\r\n\t\t\t\t\tmargin-bottom: 2px;\r\n\r\n\t\t\t\t\th4 {\r\n\t\t\t\t\t\tfont-size: 16px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardWrp {\r\n\t\t&.packagesCard {\r\n\t\t\t.packageItem {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\tpadding: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.packageImageWrp {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: auto;\r\n\t\t\t}\r\n\r\n\t\t\t.packageFooter {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: flex-start;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.viewDetailsBtn {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vendorDetailWrp": `VendorV2_vendorDetailWrp__f6flO`,
	"backBtn": `VendorV2_backBtn__2Z+bq`,
	"contentContainer": `VendorV2_contentContainer__+b1s5`,
	"topContent": `VendorV2_topContent__B9bcb`,
	"coverImgWrp": `VendorV2_coverImgWrp__SHQod`,
	"favoriteBtn": `VendorV2_favoriteBtn__FwF3j`,
	"changeCover": `VendorV2_changeCover__rGSET`,
	"coverImg": `VendorV2_coverImg__1glve`,
	"businessDetails": `VendorV2_businessDetails__2lVnE`,
	"left": `VendorV2_left__x65u3`,
	"businessAvatar": `VendorV2_businessAvatar__qLM6m`,
	"businessProfilePic": `VendorV2_businessProfilePic__3cUjo`,
	"imgIcn": `VendorV2_imgIcn__lsyQV`,
	"businessName": `VendorV2_businessName__1q6lB`,
	"row": `VendorV2_row__UhP5F`,
	"topLabel": `VendorV2_topLabel__tXYqx`,
	"websiteAndChat": `VendorV2_websiteAndChat__BJ0Mx`,
	"bottomContent": `VendorV2_bottomContent__wzc8z`,
	"bottomContentInner": `VendorV2_bottomContentInner__xyxiA`,
	"cardWrp": `VendorV2_cardWrp__qcAsH`,
	"infoHeader": `VendorV2_infoHeader__H-PsL`,
	"editIcon": `VendorV2_editIcon__UDU0g`,
	"businessDetail": `VendorV2_businessDetail__0Qc7t`,
	"mediaInfo": `VendorV2_mediaInfo__veLIE`,
	"mediaImgContainer": `VendorV2_mediaImgContainer__KphcO`,
	"mediaImg": `VendorV2_mediaImg__xTKce`,
	"serviceInfo": `VendorV2_serviceInfo__-bulb`,
	"serviceChipsWrp": `VendorV2_serviceChipsWrp__tNY5H`,
	"chip": `VendorV2_chip__YpVTh`,
	"socialInfo": `VendorV2_socialInfo__G-uLh`,
	"socialInputFieldWrp": `VendorV2_socialInputFieldWrp__erQrT`,
	"ratingReviewCard": `VendorV2_ratingReviewCard__dSKuh`,
	"ratingNumber": `VendorV2_ratingNumber__dBELq`,
	"reviewAfterImg": `VendorV2_reviewAfterImg__gJ2ES`,
	"ratingPercent": `VendorV2_ratingPercent__GnRZ6`,
	"reviewContentWrp": `VendorV2_reviewContentWrp__VbA7D`,
	"reviewContent": `VendorV2_reviewContent__UCBbH`,
	"reviewerImg": `VendorV2_reviewerImg__fYAO2`,
	"reviewerContent": `VendorV2_reviewerContent__EKngI`,
	"packagesCard": `VendorV2_packagesCard__caNM2`,
	"packagesWrp": `VendorV2_packagesWrp__OHuuY`,
	"packageItem": `VendorV2_packageItem__1m4IX`,
	"packageImageWrp": `VendorV2_packageImageWrp__Uk38k`,
	"packageImage": `VendorV2_packageImage__8bYt8`,
	"packageImageOverlay": `VendorV2_packageImageOverlay__kvbp5`,
	"packageContent": `VendorV2_packageContent__t5McF`,
	"packageTitle": `VendorV2_packageTitle__8+LWU`,
	"packageDescription": `VendorV2_packageDescription__mFJEv`,
	"packageFooter": `VendorV2_packageFooter__7q2Dn`,
	"packagePrice": `VendorV2_packagePrice__bReQO`,
	"priceValue": `VendorV2_priceValue__q7RAz`,
	"VendorsListModalMain": `VendorV2_VendorsListModalMain__9i83D`,
	"VendorsListModal": `VendorV2_VendorsListModal__Ne5a+`,
	"VendorsListModalButtonGroup": `VendorV2_VendorsListModalButtonGroup__uRDKe`,
	"socialInputField": `VendorV2_socialInputField__ia8Ga`,
	"viewDetailsBtn": `VendorV2_viewDetailsBtn__dzdrA`
};
export default ___CSS_LOADER_EXPORT___;
